<h3>Manage Mapping</h3>
<div class="manage-mapping-section mt-2">
    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 mt-3 ">
            <mat-radio-group [disabled]="isEdit" class="col-md-12" aria-label="Content Type" name="featureType" [(ngModel)]="selectedFeatureType"
                (change)="featureTypeChange()" required>
                <mat-radio-button value="internal" [checked]="true">Internal</mat-radio-button>
                <mat-radio-button class="ml-2" value="external">External</mat-radio-button>
            </mat-radio-group>

            <mat-form-field class="col-md-10 mt-3" appearance="outline">
                <mat-label>Support Topic Name</mat-label>
                <mat-select [disabled]="isEdit" name="selectedFeature" [(ngModel)]="selectedFeature" (selectionChange)="featureChange()">
                    <mat-option *ngFor="let feature of features" [value]="feature">
                        {{feature.controls[0].featureName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="selectedFeature && selectedFeature.controls && selectedFeature.controls.length > 0" appearance="outline"
                class="col-md-10">
                <mat-label>Support Topic Display Name</mat-label>
                <input matInput placeholder="Feature" [(ngModel)]="selectedFeature.controls[0].controlName" disabled>
            </mat-form-field>
            <mat-form-field *ngIf="selectedFeature && selectedFeature.controls && selectedFeature.controls.length > 0" appearance="outline"
                class="col-md-10">
                <mat-label>Status</mat-label>
                <input matInput placeholder="Feature" [(ngModel)]="selectedFeature.status" disabled>
            </mat-form-field>
            <mat-form-field *ngIf="selectedFeature && selectedFeature.controls && selectedFeature.controls.length > 0" class="col-md-10"
                appearance="outline">
                <mat-label>Generation</mat-label>
                <mat-select [disabled]="isEdit" name="selectedFeature" [(ngModel)]="selectedGeneration" (selectionChange)="generationChange($event.value)">
                    <mat-option *ngFor="let generation of generationList" [value]="generation">
                        {{generation}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox *ngIf="selectedGeneration" class="col-md-6" [checked]="showExisting" [(ngModel)]="showExisting" (change)="showExistingChange()"
                labelPosition="after">Copy from Existing</mat-checkbox>
            <span *ngIf="showExisting" class="float-right ml-auto col-md-6 ">
                <button [disabled]='!copySelectedFeature.issueId' [ngStyle]="{'opacity': !copySelectedFeature.issueId ? '0.7':'1'}" class="ml-2 btn btn-default"
                    type="button" (click)="copyExistingMapping()">Copy</button>
            </span>
            <mat-form-field *ngIf="showExisting" class="col-md-10 mt-3" appearance="outline">
                <mat-label>Source Support Topic Type</mat-label>
                <mat-select [disabled]="isEdit" [(ngModel)]="copySelectedFeatureType" (selectionChange)="copyFeatureTypeChange()">
                    <mat-option value="internal">Internal
                    </mat-option>
                    <mat-option value="external">External
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="showExisting" class="col-md-10 mt-3" appearance="outline">
                <mat-label>Source Support Topic Name</mat-label>
                <mat-select [disabled]="isEdit" [(ngModel)]="copySelectedFeature" (selectionChange)="copyFeatureChange()">
                    <mat-option *ngFor="let feature of copyFeatures" [value]="feature">
                        {{feature.controls[0].featureName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-6 mt-3" *ngIf="vehicleDataSource && vehicleDataSource.data.length >0">
            <div class="">
                <h3 *ngIf="!isEdit && !copyExisting">{{mappedModels.length}} models mapped for {{selectedFeature.controls[0].featureName}} for Generation {{selectedGeneration}}</h3>
                <h3 *ngIf="!isEdit && copyExisting">{{mappedModels.length}} models mapped for {{copySelectedFeature.controls[0].featureName}} for Generation
                    {{selectedGeneration}}
                </h3>
                <mat-form-field class="float-left">
                    <input matInput (keyup)="applyFilter($event.target.value)" [(ngModel)]="searchValue" placeholder="Search">
                </mat-form-field>
                <span *ngIf="!isEdit && mappedModels.length > 0 && !copyExisting" class="float-right ml-auto">
                    <button class="ml-2 btn btn-browse" type="button" (click)="unmappingModels()">Unmap Models</button>
                </span>
                <span *ngIf="!isEdit && unmappedModels.length > 0 && !copyExisting" class="float-right ml-auto">
                    <button class="ml-2 btn btn-default" type="button" (click)="mappingModels()">Map Models</button>
                </span>
                <div class="col-12 d-flex mb-4 legend-table">
                    <span class="col" *ngFor="let legend of compatibleLegend">
                        <span class="mr-3">
                            <span class="material-icons" [ngClass]="legend.value" style="font-size: 30px;"></span>
                        </span>
                        <span class="legend-text">{{legend.name}}</span>
                    </span>
                </div>
                <!-- Material Table -->
                <table aria-describedby="mapping" aria-labelledby="mapping" mat-table [dataSource]="vehicleDataSource" matSort class="col-md-12 mat-elevation-z8">
                    <ng-container matColumnDef="select">
                        <th id="mapping-all" [hidden]="isEdit==false" class="resource-header-card w-20" mat-header-cell *matHeaderCellDef>
                            <mat-checkbox class="pl-checkbox" [(ngModel)]="isSelectAll" (change)="selectAll($event)">
                            </mat-checkbox>
                            <span class="ml-2">Select All</span>
                        </th>
                        <td [hidden]="isEdit==false" [ngClass]="{'is-mapped': element.mapped === true}" mat-cell *matCellDef="let element">
                            <mat-checkbox class="pl-checkbox" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container class="ml-2" matColumnDef="model">
                        <th id="mapping-model" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Model </th>
                        <td [ngClass]="{'is-mapped': element.mapped === true}" mat-cell *matCellDef="let element"> {{element.model}} </td>
                    </ng-container>
                    <ng-container matColumnDef="year">
                        <th id="mapping-year" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
                        <td [ngClass]="{'is-mapped': element.mapped === true}" mat-cell *matCellDef="let element"> {{element.year}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
                <span *ngIf="isEdit" class="float-right ml-auto">
                    <button class="ml-2 btn btn-browse" type="button" (click)="cancelMapping()">Cancel</button>
                </span>
                <span *ngIf="isEdit" class="float-right ml-auto">
                    <button [disabled]="selection.selected.length==0" [ngStyle]="{'opacity': selection.selected.length==0 ? '0.7':'1'}" class="ml-2 btn btn-default"
                        type="button" (click)="saveMapping()">Save</button>
                </span>

            </div>
        </div>
    </div>
</div>